module.exports = __webpack_public_path__ + "media/images/pages/img_cover_right_03-8296a1ea60d193c6f49fed7a1cca265d.jpg";